import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { useLang } from "../i18n";
import { ChevronRight } from "lucide-react";

export function MdText({ text }) {
  const bold = (s) =>
    s.split(/\*\*(.+?)\*\*/g).map((part, i) =>
      i % 2 === 1 ? <strong key={i} className="text-white font-semibold">{part}</strong> : part);
  const italic = (s) => (typeof s === "string" ? s : s);
  return (
    <div className="space-y-3">
      {text.split("\n").map((line, i) => {
        const l = line.trim();
        if (!l) return null;
        if (l.startsWith("## ")) return <h2 key={i} className="font-heading text-xl font-bold text-white">{l.slice(3)}</h2>;
        if (l.startsWith("### ")) return <h3 key={i} className="text-sm font-semibold text-slate-200 uppercase tracking-wider">{l.slice(4)}</h3>;
        if (l.startsWith("- ")) return <p key={i} className="text-sm text-slate-300 pl-4 border-l border-white/10">{bold(l.slice(2))}</p>;
        if (l.startsWith("*") && l.endsWith("*") && !l.startsWith("**"))
          return <p key={i} className="text-xs text-slate-500 italic">{l.slice(1, -1)}</p>;
        return <p key={i} className="text-sm text-slate-300 leading-relaxed">{italic(bold(l))}</p>;
      })}
    </div>
  );
}

export function YearlyPerformance() {
  const { lang, t } = useLang();
  const [years, setYears] = useState([]);
  useEffect(() => { api.get("/public/performance/yearly").then((r) => setYears(r.data)).catch(() => {}); }, []);
  if (!years.length) return null;
  return (
    <div data-testid="yearly-performance">
      <h2 className="text-base md:text-lg font-medium text-white mb-4">{t("yearly_title")}</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2">
        {years.map((y) => (
          <Link key={y.year} to={`/performance/${y.year}`} data-testid={`year-card-${y.year}`}
            className="group border border-white/10 bg-[#111111] p-4 hover:border-emerald-500/40 transition-colors">
            <div className="flex items-center justify-between">
              <span className="font-heading font-bold text-white">{y.year}</span>
              <ChevronRight className="w-3.5 h-3.5 text-slate-600 group-hover:text-emerald-400 transition-colors" />
            </div>
            <p className={`font-mono text-lg mt-2 ${y.pl_eur >= 0 ? "text-emerald-400" : "text-red-400"}`}>
              {y.pl_eur >= 0 ? "+" : ""}{Math.round(y.pl_eur).toLocaleString(lang === "it" ? "it-IT" : "en-GB")} €
            </p>
            <p className={`font-mono text-xs ${y.pl_pct >= 0 ? "text-emerald-400/70" : "text-red-400/70"}`}>
              {y.pl_pct >= 0 ? "+" : ""}{y.pl_pct}%
            </p>
            <p className="text-[10px] text-slate-500 font-mono mt-1">{y.n_trades} ops · WR {y.win_rate}%</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
